var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { StickyFilters } from '@web/components/Filters/StickyFilters';
import { canAccessManagerInsightsSection, getPerformanceInsightsSections, resolvePerformanceInsightsSection } from '@web/components/PerformanceReview/insightsSections';
import { ManagerTab } from '@web/components/PerformanceReview/Manager/ManagerTab';
import { useUserContext } from '@web/contexts/User';
import { getPerformanceReviewSectionComponent } from '@web/utility';
import { useFilters } from '@web/utility/hooks/useFilters';
import { PerformanceReviewSectionsEnum } from '@workalizer/shared';
export function PerformanceInsightsTabPanel() {
    var _a;
    var currentUser = useUserContext().currentUser;
    var _b = useFilters(), userId = _b.user, pageSection = _b.pageSection, orgUnitId = _b.orgUnit, dateFrom = _b.dateFrom, dateTo = _b.dateTo;
    var canAccessManagerSection = canAccessManagerInsightsSection({
        isAdmin: (_a = currentUser === null || currentUser === void 0 ? void 0 : currentUser.isAdmin) !== null && _a !== void 0 ? _a : false,
        role: currentUser === null || currentUser === void 0 ? void 0 : currentUser.role
    });
    var sections = getPerformanceInsightsSections(canAccessManagerSection);
    var section = resolvePerformanceInsightsSection(pageSection, sections);
    if (section === PerformanceReviewSectionsEnum.MANAGER_ONLY) {
        return _jsx(ManagerTab, {});
    }
    var SectionComponent = getPerformanceReviewSectionComponent(section, userId, orgUnitId, dateFrom, dateTo, { isSecondaryDiffHidden: !userId });
    return (_jsxs(_Fragment, { children: [_jsx(StickyFilters, { orgUnits: { resetUserOnAll: true } }), _jsx("div", __assign({ className: "flex flex-col gap-4 mb-6 mx-1" }, { children: SectionComponent }))] }));
}
